/**
 * 水表机构管理 api
 */
import {axiosPost} from "@/utils/request";

/**
 * 通过 nodeType 获取根节点
 * @returns {Promise | Promise<unknown>}
 */
export const findRootNodeByNodeType = (parentId) => {
  return axiosPost({
    url: '/ap-system/selectOrganization',
    data: {
      parentId:parentId
    },
    loading: false
  })
}

/**
 * 根据父nodeId 查询搜索的户
 * @param {*} data 
 * @returns 
 */
export const findAllFamilyNodeByNodeId = (data) => {
  return axiosPost({
    url: "/nodeInfo/selectNodeInfoList",
    data: {
      ...data,
      // nodeType: 'family'
    }

  })
}


/**
 * 根据条件查询节点
 * @param {*} data 
 * @returns 
 */
export const findNode = (data) => {
  return axiosPost({
    url: "/nodeInfo/selectNodeInfoList",
    data: data,
    loading: false,

  })
}

/**
 * 通过父节点nodeId 查找子节点
 * @param organId
 * @returns {Promise | Promise<unknown>}
 */
export const findChildNodeByParentNodeId = organId => {
  return axiosPost({
    url: '/nodeInfo/getChildNode',
    data: {
      organId: organId
    },
    loading: false
  })
}

/**
 * 通过父节点nodeId 查找子节点 分页
 * @param data
 * @returns {Promise<unknown>}
 */
export const findChildNodeByParentNodeIdPage = data => {
  return axiosPost({
    url: '/nodeInfo/getChildNode',
    data: data,
    loading: false
  })
}



/**
 * 增加数据
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const nodeAdd = data => {
  return axiosPost({
    url: '/ap-system/insertOrganization',
    data: data,
    tips: true,
    loading: false
  })
}
/**
 * 修改节点
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const nodeUpdate = data => {
  delete data.operateTime
  delete data.child
  return axiosPost({
    url: '/ap-system/updateOrganization',
    data: data,
    tips: true,
    loading: false
  })
}
/**
 * 通过节点id 删除节点
 * @param organId
 * @returns {Promise | Promise<unknown>}
 */
export const nodeDelete = organId => {
  return axiosPost({
    url: '/ap-system/deleteOrganization',
    data: {
      organId: organId
    },
    tips: true,
    loading: false
  })

}
/**
 * 批量删除节点信息
 * @param organId
 * @returns {Promise | Promise<unknown>}
 */
export const deleteNodeInfoBatch = nodeIds => {
  return axiosPost({
    url: '/ap-system/deleteOrganization',
    data: {
      id: nodeIds
    },
    tips: false,
    errTips: false,
    loading: false,
  })

}

/**
 * 平移节点
 * @param {*} data 
 * @returns 
 */
export const moveNode = data => {
  return axiosPost({
    url: '/nodeInfo/moveNode',
    data: data,
    loading: true,
  })
}

/**
 * 通过id 获取子节点
 */
export const getChild = data => {
  return axiosPost({
    url: `/ap-system/selectOrganization`,
    data: data,
    loading: false
  })
}


/**
 * 设置用户权限
 * @param {*} data 
 * @returns 
 */
export const setUserDataPerimission = (data) => {
  return axiosPost({
    url: "/userDataPermission/setUserDataPermission",
    data: data,
    loading: false
  })
}

/**
 * 查询关联
 * @param userId
 * @returns {Promise<unknown>}
 */
export const findRelByUserId = userId => {
  return axiosPost({
    url: '/userDataPermission/selectUserDataPermissionByUserId',
    data: {
      userId: userId
    },
    loading: false
  })
}

/**
 * 添加关联
 * @param data
 * @returns {Promise<unknown>}
 */
export const  relAdd = data => {
  return axiosPost({
    url: '/userDataPermission/insertRel',
    data: data,
    tips: true,
    loading: false
  })
}


/**
 * 删除关联
 * @param userId
 * @returns {Promise<unknown>}
 */
export const relDelete = userId => {
  return axiosPost({
    url: '/userDataPermission/daleteRel',
    data: {
      userId: userId
    },
    loading: false
  })
}